import { useLocation } from 'react-router-dom';

const ROLES_STAFF = ['administrator', 'shop_manager', 'contributor'];
const ROTAS_STAFF = ['/dashboard', '/reserva/', '/marcacao-rapida', '/auditoria-uploads'];

export const isUtilizadorStaff = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return ROLES_STAFF.includes(user?.roles?.[0]);
    } catch (error) {
        return false;
    }
};

// Back-office: funcionário autenticado numa página de gestão. Os clientes que abrem a reserva por link veem o site normal.
export function useAreaStaff() {
    const { pathname } = useLocation();
    return isUtilizadorStaff() && ROTAS_STAFF.some(rota => pathname.startsWith(rota));
}
